import { UserType } from "type/user.type";
import V1WebAbstractUserClientDTO from "./v1webabstractuserclient.dto";

/**
 * @author Von Frank - https://vonfrank.dk
 */

export default class V1WebUserClientOperatorDTO extends V1WebAbstractUserClientDTO {

  constructor() {
    super();
    this.abstractUserUserType = UserType.OPERATOR;
  }
}